import type {
  StorefrontAggregated,
  StorefrontAggregatedParams,
} from './storefrontContract';

import { type ApiResponse, estClient } from './estClient';

export * from './storefrontContract';

class StorefrontApi {
  /**
   * The projection follows the session - narrow the result by `is_authorized`
   */
  async getAggregated({
    objectIds,
    noCache,
    asGuest,
  }: StorefrontAggregatedParams = {}): Promise<StorefrontAggregated> {
    return estClient.get<ApiResponse<StorefrontAggregated>>(
      '/api/storefront/aggregated',
      {
        query: {
          ...(objectIds?.length ? { object_ids: objectIds.join(',') } : {}),
          ...(noCache ? { no_cache: 1 } : {}),
          ...(asGuest ? { as_guest: 1 } : {}),
        },
      },
    );
  }
}

export const storefrontApi = new StorefrontApi();
